<template>
  <div id="knowledge" class="dash-item dash-knowledge col-md-4">
    <div class="box-header dash-bg-color-skin-light-10">
      <div class="header-left cursor-pointer col-xs-2">
        <div class="rec"></div>
        <i class="fa fa-chevron-left" v-show="!knowledgeIndexDisp" @click="toggle('index')"></i>
        <i class="fa fa-search" v-show="knowledgeIndexDisp" @click="toggle('search')"></i>
      </div>
      <div class="header-center col-xs-8">
        {{ app.home[app.nowLang].knowledge }}
      </div>
      <div class="header-right col-xs-2">
        <i class="fa fa-refresh cursor-pointer" v-show="knowledgeIndexDisp" @click="refresh()"></i>
      </div>
    </div>
    <div class="box-content">
      <knowledge-search class="form-design" v-show="knowledgeSearchDisp || pcDisp" 
              :toggle="toggle" 
              :receivedKnowledgesInfiniteLoading="receivedKnowledgesInfiniteLoading" 
              :pcDisp="pcDisp" 
              :knowledgeIndexDisp="knowledgeIndexDisp"
              @enableTriggerResetBool="triggerResetBool = true"
              v-model="subject"
              :nowLang="app.nowLang"
              :labels="labels" />
  		<knowledge-index v-show="knowledgeIndexDisp" 
              :knowledges="knowledges" 
              :getKnowledge="getKnowledge" 
              :subject="subject" 
              :receivedKnowledgesInfiniteLoading="receivedKnowledgesInfiniteLoading"
              :triggerKnowledgeInfiniteBool="triggerKnowledgeInfiniteBool" 
              :triggerResetBool="triggerResetBool" 
              @disableTriggerResetBool="triggerResetBool = false" />
  		<knowledge-detail v-show="knowledgeDetailDisp" :knowledge="knowledge" />
		</div>
  </div>
</template>

<script>
import knowledgeIndex from 'components/knowledge/index'
import knowledgeSearch from 'components/knowledge/search'
import knowledgeDetail from 'components/knowledge/detail'
import * as types from 'store/modules/knowledge/mutation-types'
import { mapActions } from 'vuex'

export default {
  name: 'knowledge',
  data () {
    return {
      subject: '',
      app: this.$parent.$parent.$parent.$parent,
      store: this.$store,
      labels: {
        en: {
          searchPlaceHolder: 'Tile / Course Name',
          search: 'Search'
        },
        th: {
          searchPlaceHolder: 'หัวข้อ / ชื่อหลักสูตร',
          search: 'ค้นหา'
        }
      },
      knowledgeIndexDisp: true,
      knowledgeSearchDisp: false,
      knowledgeDetailDisp: false,
      params: {},
      knowledge: {},
      triggerResetBool: false
    }
  },
  watch: {
    subject (newVal) {
      this.subject = newVal
    }
  },
  props: [ 'pcDisp', 'triggerKnowledgeInfiniteBool' ],
  components: {
    knowledgeIndex,
    knowledgeSearch,
    knowledgeDetail
  },
  methods: {
    refresh () {
      this.subject = ''
      this.triggerResetBool = true
    },
    toggle (page) {
      this.knowledgeIndexDisp = false
      this.knowledgeSearchDisp = false
      this.knowledgeDetailDisp = false
      switch (page) {
        case 'index':
          this.knowledgeIndexDisp = true
          break
        case 'search':
          this.knowledgeSearchDisp = true
          break
        case 'detail':
          this.knowledgeDetailDisp = true
          break
        default:
          this.knowledgeIndexDisp = true
          break
      }
    },
    getKnowledge (knowledge) {
      this.knowledge = knowledge
      this.toggle('detail')
    },
    ...mapActions({
      receivedKnowledgesInfiniteLoading: types.RECEIVED_KNOWLEDGES_INFINITE_LOADING
    })
  }
}
</script>

<style src="./style.scss" lang='scss'></style>



// WEBPACK FOOTER //
// component.vue?17c8fdc1